module.exports = __webpack_public_path__ + "img/celular2.beda2b72.svg";